// src/api/reactions.ts

import axios from './axiosConfig';

const base = '/api/comments';

export interface Reaction {
    id: string;
    comment_id: string;
    user_email: string;
    emoji: string;
    created_at: string;
}

/**
 * Toggle a reaction: if the user has already reacted with the emoji, it removes it.
 * Otherwise, it adds it.
 * Returns the single toggled reaction, or null if it was removed.
 */
export const toggleReaction = async (
    commentId: string,
    emoji: string
): Promise<Reaction | null> => {
    const response = await axios.post(`${base}/${commentId}/reactions`, {
        comment_id: commentId,
        emoji,
    });

    return response.data || null;
};

/**
 * Get all reactions for a specific comment.
 */
export const getReactions = async (commentId: string): Promise<Reaction[]> => {
    const response = await axios.get(`${base}/${commentId}/reactions`);
    return response.data as Reaction[];
};
